// A marca KR tem duas versões: a normal (K preto, texto preto) e a negativa
// (K prateado, texto branco). Em fundo escuro a normal some — por isso a
// escolha é pelo FUNDO onde a logo é desenhada, não pelo tema em si: o painel
// da tela de login usa theme.custom.login.bg, que é escuro em vários temas
// claros.
export const LOGO_LIGHT_BG = "/logo.png";
export const LOGO_DARK_BG = "/logo-dark.png";

const parseColor = (color) => {
  if (typeof color !== "string") return null;
  const c = color.trim();

  const hex = c.replace("#", "");
  if (/^[0-9a-f]{3}$/i.test(hex)) {
    return [0, 1, 2].map((i) => parseInt(hex[i] + hex[i], 16));
  }
  if (/^[0-9a-f]{6}$/i.test(hex)) {
    return [0, 2, 4].map((i) => parseInt(hex.substr(i, 2), 16));
  }

  const rgb = c.match(/rgba?\(([^)]+)\)/i);
  if (rgb) {
    const parts = rgb[1].split(",").map((p) => parseFloat(p));
    if (parts.length >= 3 && parts.slice(0, 3).every((n) => !Number.isNaN(n))) {
      return parts.slice(0, 3);
    }
  }

  return null;
};

// Luminância relativa (WCAG). Acima de 0.5 o fundo é considerado claro.
export const isDarkBg = (color) => {
  const rgb = parseColor(color);
  if (!rgb) return false;
  const [r, g, b] = rgb.map((v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b <= 0.5;
};

// bg: a cor de fundo onde a logo será exibida. Sem bg (ou cor não
// reconhecida), cai no modo do tema.
export const logoForBg = (theme, bg) => {
  const color = bg || theme?.palette?.background?.paper;
  const dark = parseColor(color)
    ? isDarkBg(color)
    : theme?.palette?.mode === "dark";
  return dark ? LOGO_DARK_BG : LOGO_LIGHT_BG;
};
